import React from 'react'

const Alert = ({ notification }) => {
  return (
    <div
      class="mt-5 flex items-center p-5 leading-normal text-red-600 bg-red-100 rounded-lg w-full"
      role="alert"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
        class="inline w-6 h-6 fill-current mr-2"
      >
        <g data-v-2d0d7d62="">
          <rect data-v-2d0d7d62="" fill="none" height="24" width="24"></rect>
        </g>
        <g data-v-2d0d7d62="">
          <g data-v-2d0d7d62=""></g>
          <g data-v-2d0d7d62="">
            <circle data-v-2d0d7d62="" cx="15.5" cy="9.5" r="1.5"></circle>
            <circle data-v-2d0d7d62="" cx="8.5" cy="9.5" r="1.5"></circle>
            <path
              data-v-2d0d7d62=""
              d="M12,18c2.28,0,4.22-1.66,5-4H7C7.78,16.34,9.72,18,12,18z"
            ></path>
            <path
              data-v-2d0d7d62=""
              d="M11.99,2C6.47,2,2,6.48,2,12c0,5.52,4.47,10,9.99,10C17.52,22,22,17.52,22,12C22,6.48,17.52,2,11.99,2z M12,20 c-4.42,0-8-3.58-8-8c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z"
            ></path>
          </g>
        </g>
      </svg>
      <p>{notification.text}</p>
    </div>
  )
}

export default Alert
